import { css } from 'styled-components';
import { LABEL_COLOR, PINK } from '../../../constants/colors';

export default {
  wrapper: ({ fixAutofill }) => css`
    // margin-bottom: 24px;

    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active  {
        box-shadow: 0 0 0 30px ${fixAutofill} inset;
    }
  `,
  label: ({ status }) => css`
    font-size: 10px;
    color: ${LABEL_COLOR};
    margin-top: 2px;
    opacity: 0.7;
    padding: 0 1em;
    ${status > 0
      && css`
        color: ${status === 2 ? 'red' : 'green'};
        opacity: 1;
      `};
  `,
  labelTop: css`
    font: 16px Arial, sans-serif;
    line-height: 1.5;
    color: #000000;
    margin-bottom: 0.5rem;
  `,
  input: ({ status }) => css`
    border-radius: 0.25rem;
    border-color: ${status < 1 ? PINK : status === 1 ? '#28A745' : status === 2 ? '#939393' : '#DC3545'};
    border-width: 1px;
    border-style: solid;
    color: #000000;
    display: block;
    font-size: 1rem;
    font-family: Arial, sans-serif;
    height: calc(2.25rem + 2px);
    line-height: 1.5;
    padding: 0.375rem 0.75rem;
    background-color: white;
    margin-bottom: 1rem;
    width: 100%;
    outline: none !important;
    &:focus {
      box-shadow: 0 0 0px 3px ${status === 2 ? 'rgba(220, 53, 69, 0.25)' : status === 1 ? 'rgba(40, 167, 69, 0.25)' : 'rgba(239, 96, 163, 0.25)'};
    }
  `
};
